﻿export class PropertyOpinion {
    public PDID: string;
    public FeatureName: string;
    public FeatureOpinion: string;
}